import React from "react";
import { Text } from "@amzn/meridian";
import "./CaptureInstructionBanner.scss";

export type CaptureType = "barcode" | "label" | "container";

interface CaptureInstructionBannerProps {
  type: CaptureType;
  /** Instruction text shown in the banner body beneath the title. */
  instruction: string;
}

const CAPTURE_TYPE_TITLE: Record<CaptureType, string> = {
  barcode: "Barcode",
  label: "Label",
  container: "Container",
};

/**
 * In-camera capture-screen banner: a colored title pill (BARCODE / LABEL /
 * CONTAINER) telling the inspector which part of the container they're
 * capturing, attached flush to a dark banner with that step's instruction
 * text below it. This component only renders the title + instruction pair
 */
const CaptureInstructionBanner: React.FC<CaptureInstructionBannerProps> = ({ type, instruction }) => {
  return (
    <div className="capture-instruction-banner">
      <div className={`capture-instruction-banner__title capture-instruction-banner__title--${type}`}>
        <Text type="h200" color="inverted">
          {CAPTURE_TYPE_TITLE[type].toUpperCase()}
        </Text>
      </div>
      <div className="capture-instruction-banner__body">
        <Text type="h200" color="inverted" alignment="center">
          {instruction}
        </Text>
      </div>
    </div>
  );
};

export default CaptureInstructionBanner;
